import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { useReadOnly } from "../../../utils/ReadOnlyContext";
import { getFormErrorByName, useFormErrorContext } from "../../../utils/context/FormErrorContext";
import './Dropdown.css'
import i18n from "../../../i18n";

export interface Option {
    value: string | number | readonly string[] | undefined,
    text: string,
    displayName?: string,
    disabled?: boolean,
    subOptions?: Array<Option>,
    frenchText?: string
}

export interface DropdownProps {
    onChange?: React.ChangeEventHandler;
    className?: string;
    options: Array<Option | null>;
    value?: string | number | null;
    label?: string;
    ariaLabel?: string;
    title?: string;
    id?: string;
    name: string;
    errorMessage?: string;
    hideErrorCross?: boolean;
    testid?: string;
    readOnly?: boolean;
    multiple?: boolean;
    forceEnabled?: boolean;
    disabled?: boolean;
    placeholder?: boolean
}

export default function Dropdown(props: DropdownProps): JSX.Element {

    const { onChange, className, options, value, label, ariaLabel, id, name, errorMessage, testid, title, readOnly, forceEnabled, disabled } = props
    const { isReadOnly } = useReadOnly()
    const { errors } = useFormErrorContext()

    return (
        <fieldset className='noborder-fieldset' aria-label="dropdown-section">
            <legend className='invisible-legend'><span>{label ? label : "dropdown"}</span></legend>
            {label && <h5 id={id} className="dropdown-title">{label}</h5>}
            <select disabled={forceEnabled ? false : readOnly || isReadOnly || disabled} name={name} id={id}
                className={className} value={value ?? undefined} title={title}
                onChange={(e) => onChange && onChange(e)} aria-label={ariaLabel}
                aria-labelledby={id} data-testid={testid ?? "dropdown-test"} multiple={props.multiple}
                data-primary-key={getFormErrorByName(errors, props.name as string)?.primaryKey as string}
            >
                {props.placeholder ? <option disabled={true} value={""}></option> : <></>}
                {options?.filter(option => option !== null).map((option, index) => {
                    if (option) {
                        if (option.subOptions?.length) {
                            return <optgroup key={index} label={i18n.language === "fr" ? option.frenchText || option.text : option.text}>
                                {option.subOptions.map((subOption, subIndex) => {
                                    return <option key={`${index}${subIndex}`} value={subOption.value}>{subOption.displayName}</option>
                                })}
                            </optgroup>
                        } else {
                            return <option key={index} value={option.value} disabled={option.disabled}>{i18n.language === "fr" ? option.frenchText || option.text : option.text}</option>
                        }
                    } else {
                        return <></>
                    }
                })}
            </select>
            {props.errorMessage ? <div className="input-error-message">{!props.hideErrorCross && <FontAwesomeIcon className="red-cross" icon={faCircleXmark} />}{errorMessage}</div> : ""}
        </fieldset>
    )
}